import { Suspense, lazy } from 'react'
import { Navigate } from 'react-router-dom'

import SuspenseLoader from 'src/components/SuspenseLoader'
import Users from '../scenes/security/users'
import User from '../scenes/security/users/user'
import { Roles } from '../scenes/security/roles'
import UsersPassword from '../scenes/security/users-password'
import UserPassword from '../scenes/security/users-password/user'

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  )

const WorkstationRegistrationList = Loader(lazy(() => import('../scenes/security/workstations-registration')))
const WorkstationRegistration = Loader(lazy(() => import('../scenes/security/workstations-registration/WorkstationRegistration')))

const securityRoutes = [
  {
    path: '/',
    element: <Navigate to="roles" replace />,
  },
  {
    path: 'roles',
    element: <Roles />,
  },
  {
    path: 'users',
    element: <Users />,
  },
  {
    path: 'users/create',
    element: <User />,
  },
  {
    path: 'users/:id',
    element: <User />,
  },
  {
    path: 'users-password',
    element: <UsersPassword />,
  },
  {
    path: 'users-password/:id',
    element: <UserPassword />,
  },
  {
    path: 'workstations-registration',
    element: <WorkstationRegistrationList />,
  },
  {
    path: 'workstations-registration/:id',
    element: <WorkstationRegistration />,
  },
]


export default securityRoutes
